<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [limitedTo]="themeOptions.limitedTo(optionType)">
  <div app-theme-option-content>
    <div app-show-details-option-content>
      <app-check [color]="color" [value]="themeOptions.axes(axesXY, axesIndex, 'radar').gridLines['circular']" (sendValue)="receiveValue($event)"></app-check>
    </div>
  </div>
</app-theme-option>